export default function getUSDollar(value: number | string) {
  return "$" + parseFloat(value.toString()).toFixed(2);
}
